import WRAP from 'WRAP-JS'
import { configFirLayer } from "./config/ConfigFir";
import { MAP_ID_FIR } from "../../../store/MapContentsState";
import { getCycleDate } from "../../../Authorization";
import WrapOption from '../../../constants/WrapOption';
import axios from 'axios';
import { COMMUNICATE_ERROR_MESSAGE_FIR, COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER } from '../../../constants/ErrorMessage';

class FIR {
  static NAME = MAP_ID_FIR
  dh;
  layer;
  visible;
  constructor() {
    this.layer = new WRAP.Geo.Layer(FIR.NAME);
    this.layer.setVisible(false);
  }

  async initData() {
    const accessIndex = await getTileAccessIndex();
    const wrapOption = WrapOption();
    WRAP.DH.set({...wrapOption, fir_access_index: accessIndex});

    return new Promise(resolve => {
      this.dh = WRAP.DH.addObject("FIR"); //pri/conf/data/FIR.json
      this.dh.inspect(() => {
        resolve();
      });
    });
  }

  async drawLayer(visible) {
    this.visible = visible
    if (!this.dh) {
      await this.initData();
      this.layer.configure(this.dh, configFirLayer);
    }
    this.setVisible(this.visible);
  }
  getLayer() {
    return this.layer;
  }

  getLegend() {
    return {
      id: FIR.NAME,
      label: 'FIR'
    }
  }

  setVisible(visible) {
    if (visible) {
      this.layer.show();
    } else {
      this.layer.hide();
    }
  }

  tooltip(layer, reference) {
    if (!reference || !reference.geo || !reference.geo.properties) return;

    return `${reference.geo.properties.icao}<hr/>${reference.geo.properties.name}`;

  }
}

const getTileAccessIndex = async () => {
  const apiUrl = process.env.REACT_APP_ARINC_DATA_AUTH_API_URL;
  const apiKey = process.env.REACT_APP_ARINC_DATA_AUTH_API_KEY;
  const config = {
    method: 'get',
    url: `${apiUrl}/auth/fir`,
    headers: { 
      'x-api-key': apiKey
    },
    errorHandle: {
      message: COMMUNICATE_ERROR_MESSAGE_FIR,
      additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER
    }
  };
  
  return await axios(config)
    .then(response => {
      if (response && response.data && Array.isArray(response.data)) {
        const cycleDate = getCycleDate();
        const target = response.data.find(data => data.Cycledate === cycleDate);
        return target?.Prefix;
      }
    })
    .catch(e => {
      console.log('Failed to get FIR tile access index.', e);
      throw e;
    });
};

export default FIR;